/** Shopify CDN: Minification failed

Line 89:2 Transforming let to the configured target environment ("es5") is not supported yet
Line 90:2 Transforming let to the configured target environment ("es5") is not supported yet
Line 91:2 Transforming const to the configured target environment ("es5") is not supported yet
Line 93:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 94:2 Transforming const to the configured target environment ("es5") is not supported yet
Line 104:2 Transforming const to the configured target environment ("es5") is not supported yet

**/

$(document).ready(function(){
  $('.lb-img-trigger').click(function(element) {
    var trigger = $(element.currentTarget);
    var lburl = $(this).attr('data-url');
    var container = $('.lb-img-modal-inner');
    container.css({ display: 'flex', flexDirection: 'row', alignItems: 'center' });
    var img = container.find('img');
    img.attr('src', lburl);

    var navCss = { color: 'white', cursor: 'pointer', fontSize: '64px' };
    var prv = $('<div class="lb-img-modal-prv">&lsaquo;</div>');
    var nxt = $('<div class="lb-img-modal-nxt">&rsaquo;</div>');

    var toggleArrows = function() {
      if (trigger.prev().is('.lb-img-trigger')) {
        prv.css({ opacity: 1 });
      } else {
        prv.css({ opacity: 0 });
      }

      if (trigger.next().is('.lb-img-trigger')) {
        nxt.css({ opacity: 1 });
      } else {
        nxt.css({ opacity: 0 });
      }
    }
    var loadNeighbor = function(neighbor) {
      console.log('neighbor', neighbor)
      if (neighbor.is('.lb-img-trigger')) {
        trigger = neighbor;
        img.attr('src', neighbor.data('url'));
        toggleArrows()
      }
    }

    prv.css(navCss)
    img.before(prv);
    prv.click(function() { loadNeighbor(trigger.prev()) });

    nxt.css(navCss)
    img.after(nxt);
    nxt.click(function() { loadNeighbor(trigger.next()) });

    toggleArrows();
    $('.lb-img-modal').fadeIn();
    $('body').addClass('lb-modal-open');
    return false;
  });

    $('nav .menu-collection').click(function() {
          $('.header__drawer').removeClass('drawer--visible');
      $('.header__drawer').addClass('display-none');
          $('body').css('overflow', '');
          $('html').removeAttr('data-scroll-locked');
      });

  $('.col-slider').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
    autoplay: true,
  autoplaySpeed: 2000,
    dots: true,
  infinite: true,
  speed: 2000,
  fade: true,
    arrows: false,
});



  $(document).click(function(e) {
    if(!$.contains($('.lb-img-modal-inner')[0], e.target)){
      $('.lb-img-modal-prv,.lb-img-modal-nxt').hide();
      $('.lb-img-modal').fadeOut();
      $('body').removeClass('lb-modal-open');
    }
  });

  $('.lb-modal-close').click(function() {
    var lburl = $(this).attr('data-url');
    $('.lb-img-modal-prv,.lb-img-modal-nxt').hide();
    $('.lb-img-modal').fadeOut();
    $('body').removeClass('lb-modal-open');
  });

  // $("body").delay(200).animate({ opacity: 1 }, 900);
  // $(".efdelay").delay(400).animate({ opacity: 1 }, 900);

  // $('.if-img-wrap').Parlx({
  //      item: '.if-img',
  //   height: '53vw'
  // });

  $(window).on('load resize orientationchange', function() {
      var wdt = $("body").width();
      var wrp = $(".wrapper").width();
      var mrg = (wdt-wrp)/2;
      var mrgpx =  -(mrg)+'px';

      $(".lkb-img.lkb-img-50fl").css({
        "font-size": 0,
        "margin-left": `${((mrg * -1) + 5.5)}px`,
        "padding": "6px 0"
      }).width((wdt / 2));

      $(".lkb-img.lkb-img-50fr").css({
        "font-size": 0,
        "margin-right": `${(mrg * -1)}px`,
        "padding": "6px 0"
      }).width((wdt / 2));
  });
});



/* Load More Button */

$(document).ready(() => {
  let lastTop = 0;
  let rowNum = 0;
  const rowsToDisplay = 7;
  $('.lkb-img-each').each((index, element) => {
    const img = $(element).parent();
  const top = img.position().top;
    if (top > lastTop) {
      rowNum += 1;
    }
    if (rowNum > rowsToDisplay) {
      img.addClass('lkb-img-load-more');
    }
    lastTop = top;
  });

  const btn = $('#btn-load-more');
  btn.click((event) => {
    event.preventDefault();
    btn.hide();
    $('.lkb-img-load-more').fadeIn(2000);
  });

  if (rowNum <= rowsToDisplay) {
    btn.hide();
  }
});

$(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();

    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top
    }, 500);
});


$(window).scroll( function(){
  $('.scrl').each( function(i){
      var elemPos = $(this).offset().top,
      scroll = $(window).scrollTop(),
      windowHeight = $(window).height();
      if (scroll > elemPos - windowHeight + 200){
          $(this).addClass("scrld");
      }

  });


});

   if (document.cookie.indexOf("popupShown=true") == -1) {
    document.cookie = "popupShown=true; max-age=86400";
    $('#shopify-section-template--16614856163491__newsletter_DLtmMA').show();
    $('body').addClass('signup-show');
}

  if($('body').hasClass("signup-show")){
  $(document).click(function(e) {

      if(!$.contains($('#shopify-section-template--16614856163491__newsletter_DLtmMA .contact-form')[0], e.target)){
          $('#shopify-section-template--16614856163491__newsletter_DLtmMA').fadeOut();
        }

    });
     }
